import { ComponentSingleStyleConfig } from "@chakra-ui/react";

export const badgeTheme: ComponentSingleStyleConfig = {
  baseStyle: {
    textTransform: "none",
  },
};
export const Alert = {
  parts: ["container", "title", "description", "icon"],
  baseStyle: {
    container: {
      alignItems: "flex-start",
    },
    icon: {
      mt: "2px",
    },
  },
};
